import React, { useState, useEffect } from "react";
import { Inicio } from "../shered/components";
import { AuthService } from "../shered/services/autenticacao/AuthService";


type Props = {
    children?: React.ReactNode,
};
export const ProtectedRoutes: React.FC<Props> = ({ children }) => {
    const [auth, setAuth] = useState(false)  

    useEffect(() => {
        const fetchData = async () => {            
            let resp = await AuthService.authenticated();           
            if (resp) {
                setAuth(true);
            }              
        }
        fetchData();
    }, [auth])

    return auth ? <>{children}</> : <Inicio visivel={auth} />;
}

